/*
 * @Author: Gang Jiang 
 * @Date: 2024-11-07 14:47:19 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-27 17:31:32
 */
<template>
  <div
    ref="zjdgx"
    class="links-analytisc"
  >
    <div class="bread-crumb">
      Links Analytics
    </div>
    <h2>Links Analytics</h2>
    <div class="content">
      <a-spin :spinning="isLoading">
        <a-form
          class="search"
          :model="filter"
        >
          <a-row :gutter="[10, 0]">
            <a-col :span="8">
              <a-form-item
                :label-col="{ span: 9 }"
                label="Iwrd Link"
              >
                <a-input
                  v-model:value="filter.shortName"
                  :allow-clear="true"
                  placeholder="Please enter"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                :label-col="{ span: 9 }"
                label="Username"
              >
                <a-auto-complete
                  v-model:value="filter.userName"
                  :allow-clear="true"
                  placeholder="Please enter"
                  :options="userSuggestions"
                  @select="onUserSelect"
                  @clear="clearUser"
                  @blur="suggestionBlur"
                  @search="(val) => onUserSearch(val, 'userName')"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                :label-col="{ span: 9 }"
                label="Influencer Email"
              >
                <a-auto-complete
                  v-model:value="filter.email"
                  :allow-clear="true"
                  placeholder="Please enter"
                  :options="emailSuggestions"
                  @select="onUserSelect"
                  @clear="clearUser"
                  @blur="suggestionBlur"
                  @search="(val) => onUserSearch(val, 'email')"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                :label-col="{ span: 9 }"
                label="Advertiser Name"
              >
                <a-auto-complete
                  v-model:value="filter.advertiserName"
                  :allow-clear="true"
                  placeholder="Please enter"
                  :options="advertiserNameSuggestions"
                  @select="onSelectAdvertiser"
                  @clear="clearAdvertiser"
                  @blur="advertiserBlur"
                  @search="onAdvertiserSearch"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                :label-col="{ span: 9 }"
                label="Affiliate"
              >
                <a-select
                  v-model:value="filter.affiliateId"
                  allow-clear
                  placeholder="Select"
                  :options="affiliateList"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                :label-col="{ span: 9 }"
                label="Social Platform"
              >
                <a-select
                  v-model:value="filter.socialPlatformId"
                  allow-clear
                  placeholder="Select"
                  :options="socialPlatforms"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                :label-col="{ span: 9 }"
                label="Time Range"
              >
                <a-range-picker
                  v-model:value="filterDate"
                  :style="{ width: '100%' }"
                  :disabled-date="disabledDate"
                  format="YYYY-MM-DD"
                  :allow-clear="false"
                  :placeholder="['Start date', 'End date']"
                  @change="setFilterDate"
                />
              </a-form-item>
            </a-col>
            <a-col class="btns">
              <a-button
                type="primary"
                @click="onSearch"
              >
                Search
              </a-button>
              <a-button @click="resetSearch">
                Reset
              </a-button>
              <a
                :href="`https://${apiDomain}/admin/influencer-marketing/v1/link/analytics/list/export?${exportUrlParams}`"
                download
              ><a-button type="primary">Export</a-button></a>
            </a-col>
          </a-row>
        </a-form>
        <a-table
          :data-source="linkList"
          :columns="columns()"
          :scroll="{ x: 2400 }"
          :pagination="pagination"
          :show-sorter-tooltip="false"
          @change="changeSort"
        >
          <template #headerCell="{ column }">
            <template v-if="column.titleTip">
              <TableTitlePopover
                :title="column.title"
                :content="column.titleTip"
              />
            </template>
          </template>
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'commissionOverall'">
              <span
                :class="
                  'overall' +
                    (record.affiliate?.hasCommissionDetails
                      ? ' has-commission'
                      : '')
                "
                @click="
                  showCommissionDetail(
                    record.affiliate?.advertiserAffiliateRelationId
                  )
                "
              >{{ record.affiliate?.commissionOverview || '-' }}</span>
            </template>
            <template
              v-else-if="
                column.key === 'shortUrl' || column.key == 'originalUrl'
              "
            >
              <a
                :class="
                  column.key.replace(
                    /[A-Z]/,
                    (item) => '-' + item.toLowerCase()
                  )
                "
                :title="record[column.key]"
                :href="record[column.key]"
                target="_blank"
              >{{ record[column.key] }}</a>
              <span
                v-if="column.key == 'originalUrl' && record.title"
                class="title"
                :title="record.title"
              >{{ record.title }}</span>
            </template>
            <template
              v-else-if="column.key === 'commission' || column.key === 'sales'"
            >
              <span v-if="record[column.key]">${{ record[column.key] }}</span>
            </template>
            <template v-else-if="column.key === 'path'">
              <a
                v-if="record.homepage"
                :href="record.homepage"
                target="_blank"
              >{{ record.domain + record.path }}</a>
              <span v-else>{{ record.domain }}{{ record.path }}</span>
            </template>
          </template>
        </a-table>
      </a-spin>
    </div>
    <a-modal
      v-model:open="showCommissionList.length"
      :get-container="() => $refs.zjdgx"
      title="Commision Details"
      :width="1000"
      :footer="null"
      class="commission-detail-modal"
      @ok="showCommissionList = []"
      @cancel="showCommissionList = []"
    >
      <CommissionDetail :commission-list="showCommissionList" />
    </a-modal>
  </div>
</template>

<script setup>
import moment from 'moment'
import { reactive, ref, watch } from 'vue'
import { apiDomain } from '../../../config'
import CommissionDetail from '../../components/commissionDetail.vue'
import TableTitlePopover from '../../components/tableTitlePopover.vue'
import { advertiser, influencers, user, linksAnalytics } from '../../server'

const isLoading = ref(false)
const initialFilters = {
  page: 1,
  size: 200,
  email: '',
  userName: '',
  affiliateId: null,
  influencerId: null,
  shortName: null,
  advertiserId: null,
  advertiserName: '',
  sort: '-commission',
  socialPlatformId: null,
  beginTime: moment().subtract(180, 'days').startOf('date').valueOf(),
  endTime: moment().endOf('date').valueOf(),
}
const filterDate = ref([
  moment(initialFilters.beginTime),
  moment(initialFilters.endTime),
])
const search = reactive({ ...initialFilters })
const filter = ref({ ...initialFilters })
const exportUrlParams = ref(
  'sort=-commission&beginTime=' +
    initialFilters.beginTime +
    '&endTime=' +
    initialFilters.endTime
)
const defaultColumns = [
  {
    title: 'Iwrd Link',
    dataIndex: 'shortUrl',
    key: 'shortUrl',
    fixed: 'left',
  },
  {
    title: 'Original Link',
    dataIndex: 'originalUrl',
    key: 'originalUrl',
  },
  {
    title: 'UserID',
    dataIndex: 'influencerId',
    key: 'influencerId',
    width: 80,
  },
  {
    title: 'Username',
    dataIndex: 'userName',
    key: 'userName',
  },
  {
    title: 'Sub User ID',
    dataIndex: 'subInfluencerId',
    key: 'subInfluencerId',
    width: 116,
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    width: 200,
  },
  {
    // 2024/11/07 15:32:51 ZJDGX TODO: aaaa
    title: 'Commission Overall',
    dataIndex: 'commissionOverall',
    key: 'commissionOverall',
  },
  {
    title: 'Clicks',
    dataIndex: 'clicks',
    key: 'clicks',
    sorter: true,
    width: 90,
  },
  {
    title: 'Commission',
    dataIndex: 'commission',
    key: 'commission',
    sorter: true,
    width: 130,
  },
  {
    title: 'Sales',
    dataIndex: 'sales',
    key: 'sales',
    sorter: true,
    width: 80,
  },
  {
    title: 'Orders',
    dataIndex: 'orders',
    key: 'orders',
    sorter: true,
    width: 100,
  },
  {
    title: 'C_O',
    dataIndex: 'co',
    key: 'co',
    width: 100,
    titleTip: 'Click-to-order conversion rate',
  },

  {
    title: 'Items Sold',
    dataIndex: 'items',
    key: 'items',
    sorter: true,
    width: 120,
  },
  {
    title: 'C_I',
    dataIndex: 'ci',
    key: 'ci',
    width: 100,
    titleTip: 'Click-to-item conversion rate',
  },
  {
    title: 'Advertiser Name',
    dataIndex: 'advertiserName',
    key: 'advertiserName',
    width: 220,
  },
  {
    title: 'Advertiser Domain(Path)',
    dataIndex: 'path',
    key: 'path',
    width: 200,
  },
  {
    title: 'Affiliate',
    dataIndex: 'affiliateName',
    key: 'affiliateName',
  },
  {
    title: 'Social Platform',
    dataIndex: 'socialPlatformName',
    key: 'socialPlatformName',
    fixed: 'right',
  },
]
const sorterInfo = ref({
  columnKey: 'commission',
  order: 'descend',
})
const columns = () =>
  defaultColumns.map((item) => {
    if (
      ['clicks', 'commission', 'sales', 'orders', 'items'].indexOf(
        item.dataIndex
      ) !== -1
    ) {
      return {
        ...item,
        sorter: true,
        sortOrder:
          sorterInfo.value.columnKey == item.key && sorterInfo.value.order,
      }
    } else {
      return item
    }
  })
const pagination = ref({
  current: 1,
  size: 'large',
  pageSize: 200,
  total: 0,
  showSizeChanger: false,
  onChange: (page) => {
    search.page = page
    getList()
  },
})

const linkList = ref([])
const affiliateList = ref([])
const socialPlatforms = ref([])

influencers.getSocialPlatformsList().then((res) => {
  if (res.success) {
    socialPlatforms.value = res.data.map((item) => {
      return {
        ...item,
        label: item.name,
        value: item.id,
      }
    })
  }
})

advertiser.getAffiliateList().then((res) => {
  if (res.success) {
    affiliateList.value = res.data.map((item) => {
      return {
        ...item,
        label: item.name,
        value: item.id,
      }
    })
  }
})

function disabledDate(current) {
  if (!filterDate.value || filterDate.value.length === 0) {
    return current.isAfter(moment())
  }
  const tooLate =
    filterDate.value[0] && current.diff(filterDate.value[0], 'days') > 180
  const tooEarly =
    filterDate.value[1] && filterDate.value[1].diff(current, 'days') > 180

  return tooEarly || tooLate || current > moment().endOf('date')
}

function getList() {
  isLoading.value = true
  const params = { ...search }

  Object.keys(params).forEach((key) => {
    if (params[key] == null || params[key] == '' || params[key] == undefined) {
      delete params[key]
    }
  })
  ;['userName', 'email', 'advertiserName'].forEach((key) => {
    delete params[key]
  })

  linksAnalytics.getList(params).then((res) => {
    isLoading.value = false

    if (res.success) {
      linkList.value = res.data
      pagination.value.current = params.page

      if (params.page === 1) {
        pagination.value.total = res.total
      }
    }
  })
}

getList()

function onSearch() {
  Object.assign(search, { ...filter.value, page: 1 })
  getList()
}

function resetSearch() {
  Object.assign(search, { ...initialFilters })
  Object.assign(filter.value, { ...initialFilters })
  userSuggestions.value = []
  emailSuggestions.value = []
  sorterInfo.value = {
    columnKey: 'commission',
    order: 'descend',
  }
  filterDate.value = [
    moment(initialFilters.beginTime),
    moment(initialFilters.endTime),
  ]
  getList()
}

// user suggestion
const userSuggestions = ref([])
const emailSuggestions = ref([])
let userSuggestionSelected = false

function suggestionBlur() {
  if (!userSuggestionSelected) {
    clearUser()
  }
}
function clearUser() {
  filter.value.email = null
  filter.value.userName = null
  filter.value.influencerId = null
  filter.value.shortName = null
  userSuggestions.value = []
  emailSuggestions.value = []
  userSuggestionSelected = false
}
function onUserSearch(value, type) {
  value = value.trim()

  if (value.length) {
    user.getSuggestionList(type, {
      [type]: value,
      size: 20,
    }).then((res) => {
      if (res.success) {
        const data = res.data.map((item) => {
          return {
            ...item,
            label: item[type],
            value: item.id,
          }
        })

        userSuggestionSelected = false

        if (type == 'userName') {
          userSuggestions.value = data
          emailSuggestions.value = []
        } else {
          emailSuggestions.value = data
          userSuggestions.value = []
        }
      }
    })
  }
}
function onUserSelect(id, option) {
  if (userSuggestions.value.length || emailSuggestions.value.length) {
    filter.value.email = option.email
    filter.value.influencerId = option.id
    filter.value.shortName = null
    filter.value.userName = option.userName
    userSuggestionSelected = true
  } else {
    filter.value.email = null
    filter.value.influencerId = null
    filter.value.shortName = null
    userSuggestionSelected = false
  }
}

// advertiser suggestion
const advertiserNameSuggestions = ref([])
let advertiserSelected = false
function onSelectAdvertiser(id, option) {
  if (advertiserNameSuggestions.value.length) {
    advertiserSelected = true
    filter.value.advertiserId = option.id
    filter.value.advertiserName = option.label
  } else {
    advertiserSelected = false
    filter.value.advertiserId = null
    filter.value.advertiserName = ''
  }
}
function clearAdvertiser() {
  advertiserSelected = false
  filter.value.advertiserId = null
  advertiserNameSuggestions.value = []
}
function onAdvertiserSearch(val) {
  val = val.trim()

  if (val.length) {
    advertiser.getSuggestionList({ name: val, size: 20 }).then((res) => {
      if (res.success) {
        advertiserNameSuggestions.value = res.data.map((item) => {
          return { ...item, label: item.advertiserName, value: item.id }
        })
      }
    })
  }
}
function advertiserBlur() {
  if (!advertiserSelected) {
    filter.value.advertiserId = null
    filter.value.advertiserName = ''
    advertiserNameSuggestions.value = []
  }
}

// time range
function setFilterDate(values) {
  if (!values) {
    values = [moment().subtract(180, 'days'), moment()]
    setTimeout(() => {
      filterDate.value = values
    }, 0)
  }

  filter.value.endTime = values[1].endOf('date').valueOf()
  filter.value.beginTime = values[0].startOf('date').valueOf()
}

// export
watch(filter.value, (val) => {
  let params = ''
  const temp = { ...val }

  Object.keys(temp).forEach((key) => {
    if (temp['id']) {
      delete temp.userName
    }

    if (
      temp[key] &&
      ['page', 'size', 'name', 'email', 'advertiserName'].indexOf(key) == -1
    ) {
      params = params + '&' + key + '=' + temp[key]
    }
  })

  exportUrlParams.value = params.substring(1)
})

// 排序
function changeSort(pagination, filters, sorter, { action }) {
  if (action === 'sort') {
    if (search.sort?.indexOf(sorter.field) != -1) {
      search.sort = (search.sort?.startsWith('-') ? '%2B' : '-') + sorter.field
      sorterInfo.value.order = search.sort?.startsWith('-')
        ? 'descend'
        : 'ascend'
    } else {
      sorterInfo.value.order = 'descend'
      search.sort = '-' + sorter.field
    }

    filter.value.sort = search.sort
    sorterInfo.value.columnKey = sorter.columnKey

    search.page = 1
    getList()
  }
}

// commission弹窗
const showCommissionList = ref([])
function showCommissionDetail(advertiserAffiliateRelationId) {
  if (advertiserAffiliateRelationId) {
    advertiser.commissionDetail(advertiserAffiliateRelationId).then((res) => {
      if (res.success) {
        showCommissionList.value = res.data
      } else {
        message.error('Network error, try again.')
      }
    })
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/less/common.less';
.content {
  margin-bottom: 20px;
}
.search {
  padding: 20px;
  .btns {
    width: 100%;
    text-align: right;
    .ant-btn-default {
      margin: 0 20px;
    }
  }
}

.original-url {
  max-height: 44px;
  .multiple-ellipsis(2);
}

.title {
  display: block;
  max-height: 44px;
  .multiple-ellipsis(2);
}

.has-commission {
  cursor: pointer;
  color: #1677ff;
  text-decoration: underline;
  &:hover {
    color: #ff285a;
  }
}
</style>